export function updateLocalStorageItem(key, newData) {
  const existing = JSON.parse(localStorage.getItem(key) || "{}");
  const updated = { ...existing, ...newData };
  localStorage.setItem(key, JSON.stringify(updated));
}
